export const TEAM_BASE = "/manage/app/team";

export const TEAM_ROLE_LABELS = {
  owner: "Владелец",
  admin: "Администратор",
  trainer: "Тренер",
};
